export type Severity = 'Low' | 'Medium' | 'High' | 'Critical';
export type IncidentStatus = 'Submitted' | 'Approved' | 'Rejected';

export interface Incident {
  id: string;
  caseTypeId: string;
  date: string; // ISO yyyy-mm-dd
  stateId: string;
  regionId: string;
  districtId: string;
  location: string;
  agencyId: string;
  description: string;
  numCases: number;
  numDeaths: number;
  numInjuries: number;
  severity: Severity;
  status: IncidentStatus;
  createdAt: string;
  reviewedAt?: string;
  reviewNote?: string;
}

export interface IncidentInput {
  caseTypeId: string;
  date: string;
  stateId: string;
  regionId: string;
  districtId: string;
  location: string;
  agencyId: string;
  description: string;
  numCases: number;
  numDeaths: number;
  numInjuries: number;
  severity: Severity;
}

export const SEVERITY_OPTIONS: Severity[] = ['Low', 'Medium', 'High', 'Critical'];
export const STATUS_OPTIONS: IncidentStatus[] = ['Submitted', 'Approved', 'Rejected'];
